module.exports = __webpack_public_path__ + "45fa09f2d846e34b5f4c94d2f5031192.gif";